var _path, _path2, _mask, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentCodeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32191 7.71429C6.63084 7.71429 6.88128 7.97012 6.88128 8.28571V10C6.88128 10.6312 7.38216 11.1429 8.00002 11.1429C8.61789 11.1429 9.11877 10.6312 9.11877 10V8.28571C9.11877 7.97012 9.36921 7.71429 9.67814 7.71429C9.98707 7.71429 10.2375 7.97012 10.2375 8.28571V10C10.2375 11.2624 9.23575 12.2857 8.00002 12.2857C6.7643 12.2857 5.76254 11.2624 5.76254 10V8.28571C5.76254 7.97012 6.01298 7.71429 6.32191 7.71429Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31379 6.46796C2.36618 5.8793 2.84932 5.42857 3.42794 5.42857H5.76249V4.28571C5.76249 3.02335 6.76425 2 7.99997 2C9.2357 2 10.2375 3.02335 10.2375 4.28571V5.42857H12.5721C13.1507 5.42857 13.6338 5.8793 13.6862 6.46796L14.4906 15.5073C14.6097 16.8459 13.578 18 12.2623 18H3.73767C2.42195 18 1.39025 16.8459 1.50937 15.5073L2.31379 6.46796ZM7.99997 3.14286C7.38211 3.14286 6.88123 3.65453 6.88123 4.28571V5.42857H9.11872V4.28571C9.11872 3.65453 8.61784 3.14286 7.99997 3.14286ZM13.3765 15.6108L12.5721 6.57143L3.42794 6.57143L2.62352 15.6108C2.56396 16.2801 3.07981 16.8571 3.73767 16.8571H12.2623C12.9202 16.8571 13.436 16.2801 13.3765 15.6108Z",
    fill: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1289_18814",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 9,
    width: 12,
    height: 6,
    rx: 1.16279
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 9,
    width: 12,
    height: 6,
    rx: 1.16279,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 2.7907,
    mask: "url(#path-2-inside-1_1289_18814)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37061 10.8457V12.5968",
    stroke: "currentColor",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2417 11.7598L8.42052 11.7598",
    stroke: "currentColor",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0112 11.1211L8.72346 12.3593",
    stroke: "currentColor",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0112 12.3594L8.72346 11.1211",
    stroke: "currentColor",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4585 10.8457V12.5968",
    stroke: "currentColor",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3296 11.7598L11.5084 11.7598",
    stroke: "currentColor",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4971 12.5195L14.6759 12.5195",
    stroke: "currentColor",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0991 11.1211L11.8114 12.3593",
    stroke: "currentColor",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0991 12.3594L11.8114 11.1211",
    stroke: "currentColor",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCodeIcon);
export default __webpack_public_path__ + "static/media/payment-code-icon.caba0f4131929b9770a1b9e986a9df71.svg";
export { ForwardRef as ReactComponent };